module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("@vpp/utils");

/***/ }),
/* 1 */
/***/ (function(module) {

module.exports = JSON.parse("{\"a\":\"0.0.25\"}");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("qs");

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "@vpp/utils"
var utils_ = __webpack_require__(0);

// CONCATENATED MODULE: ./src/modules/AdBlock.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AdBlock = function AdBlock(options) {
  var _this = this;

  _classCallCheck(this, AdBlock);

  _defineProperty(this, "resolve",
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!_this.options.hasOwnProperty('AD_BLOCK')) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", _this.options.AD_BLOCK);

          case 2:
            if (!(!window.bc || typeof window.bc.usingAdBlocker !== 'function')) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", false);

          case 4:
            return _context.abrupt("return", window.bc.usingAdBlocker());

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })));

  this.options = options;
};


// CONCATENATED MODULE: ./src/modules/Postcode.js
function Postcode_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function Postcode_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { Postcode_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { Postcode_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function Postcode_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Postcode_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var POSTCODE_URL = 'https://market-cdn.swm.digital/v1/market/ip?apikey=web';

var Postcode = function Postcode(options) {
  var _this = this;

  Postcode_classCallCheck(this, Postcode);

  Postcode_defineProperty(this, "fetch",
  /*#__PURE__*/
  Postcode_asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee() {
    var postcodeUrl, response, data;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!_this.options.POSTCODE) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", _this.options.POSTCODE);

          case 2:
            if (!_this.options.DISABLE_POSTCODE_FETCH) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", null);

          case 4:
            postcodeUrl = _this.options.POSTCODE_URL || POSTCODE_URL;
            _context.prev = 5;
            _context.next = 8;
            return fetch(postcodeUrl);

          case 8:
            response = _context.sent;

            if (response.ok) {
              _context.next = 11;
              break;
            }

            return _context.abrupt("return", 2015);

          case 11:
            _context.next = 13;
            return response.json();

          case 13:
            data = _context.sent;
            return _context.abrupt("return", data.postcode);

          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](5);
            videojs.log.error('Fetch postcode failed', _context.t0);
            return _context.abrupt("return", 2015);

          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 17]]);
  })));

  this.options = options;
};


// CONCATENATED MODULE: ./src/utils/testLocalStorage.js
/* harmony default export */ var testLocalStorage = (function () {
  var test = 'test';

  try {
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
});
// CONCATENATED MODULE: ./src/modules/Telaria.js
function Telaria_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function Telaria_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { Telaria_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { Telaria_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function Telaria_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Telaria_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var TELARIA_ID = 's6syw';
var TELARIA_STORAGE_KEY = 'swmTelariaId';

var Telaria_Telaria = function Telaria(config, options) {
  var _this = this;

  Telaria_classCallCheck(this, Telaria);

  Telaria_defineProperty(this, "fetch",
  /*#__PURE__*/
  Telaria_asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee() {
    var telariaId, telariaUrl, storageKey, hasStorage, storedTelariaId, response, _telariaId;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(_this.config.DISABLE_TELARIA || _this.config.GDPR_MODE || _this.options.gdprMode)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", null);

          case 2:
            telariaId = _this.config.TELARIA_ID || TELARIA_ID;
            telariaUrl = _this.config.TELARIA_URL || "https://".concat(telariaId, ".publishers.tremorhub.com/getTVID");
            storageKey = _this.config.TELARIA_STORAGE_KEY || TELARIA_STORAGE_KEY;
            hasStorage = testLocalStorage();

            if (!hasStorage) {
              _context.next = 10;
              break;
            }

            storedTelariaId = localStorage.getItem(storageKey);

            if (!storedTelariaId) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", storedTelariaId);

          case 10:
            _context.prev = 10;
            _context.next = 13;
            return fetch(telariaUrl, {
              credentials: 'include'
            });

          case 13:
            response = _context.sent;

            if (response.ok) {
              _context.next = 16;
              break;
            }

            return _context.abrupt("return", null);

          case 16:
            _context.next = 18;
            return response.json();

          case 18:
            _telariaId = _context.sent;

            if (_telariaId && hasStorage) {
              localStorage.setItem(storageKey, _telariaId);
            }

            return _context.abrupt("return", _telariaId);

          case 23:
            _context.prev = 23;
            _context.t0 = _context["catch"](10);
            videojs.log.error('Fetch telaria failed', _context.t0);
            return _context.abrupt("return", null);

          case 27:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[10, 23]]);
  })));

  this.config = config;
  this.options = options;
};


// CONCATENATED MODULE: ./src/catalogs/Catalog.js
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Catalog_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function Catalog_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { Catalog_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { Catalog_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Catalog_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function Catalog_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Catalog_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var VideoCatalog =
/*#__PURE__*/
function () {
  function VideoCatalog(player, config, options) {
    Catalog_classCallCheck(this, VideoCatalog);

    this._player = player;
    this._config = config;
    this._options = _objectSpread({
      tvId: options.telariaId,
      appId: player.el().getAttribute('data-application-id'),
      accountId: player.el().getAttribute('data-account'),
      videoId: player.el().getAttribute('data-video-embed-id')
    }, options);
    this._errorNamespace = 'SWMPlayer Catalog';
  }

  _createClass(VideoCatalog, [{
    key: "fetchVideo",
    value: function () {
      var _fetchVideo = Catalog_asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", null);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function fetchVideo() {
        return _fetchVideo.apply(this, arguments);
      }

      return fetchVideo;
    }()
  }, {
    key: "_fetchVideoService",
    value: function () {
      var _fetchVideoService2 = Catalog_asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(url) {
        var options,
            _options$headers,
            extraHeaders,
            fetchOptions,
            versions,
            headers,
            response,
            data,
            _args2 = arguments;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
                _options$headers = options.headers, extraHeaders = _options$headers === void 0 ? {} : _options$headers, fetchOptions = _objectWithoutProperties(options, ["headers"]);
                versions = JSON.stringify(this._options.versions);
                headers = new Headers(_objectSpread({
                  'X-Player-Versions': window.btoa(versions)
                }, extraHeaders));
                _context2.prev = 4;
                _context2.next = 7;
                return fetch(url, _objectSpread({
                  headers: headers
                }, fetchOptions));

              case 7:
                response = _context2.sent;

                if (response.ok) {
                  _context2.next = 10;
                  break;
                }

                return _context2.abrupt("return", null);

              case 10:
                _context2.next = 12;
                return response.json();

              case 12:
                data = _context2.sent;

                if (!data.media.reference_id) {
                  data.media.reference_id = data.media.id;
                }

                data.media.dfpUrl = data.dfp_url;
                return _context2.abrupt("return", data.media);

              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2["catch"](4);

                this._errorFetchFailed(_context2.t0);

                return _context2.abrupt("return", null);

              case 22:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 18]]);
      }));

      function _fetchVideoService(_x) {
        return _fetchVideoService2.apply(this, arguments);
      }

      return _fetchVideoService;
    }()
  }, {
    key: "_getPpId",
    value: function _getPpId() {
      var ppIdAttr = this._player.el().getAttribute('data-pp-id');

      if (ppIdAttr) return ppIdAttr;
      if (this._config.LOTAME_PPID) return this._config.LOTAME_PPID;
      var Lotame = window.Lotame;
      var ppId = Lotame && Lotame.Profile && Lotame.Profile.pid;
      return ppId || null;
    }
  }, {
    key: "_errorNoId",
    value: function _errorNoId() {
      return videojs.log.error("".concat(this._errorNamespace, ": No video ID specified"));
    }
  }, {
    key: "_errorFetchFailed",
    value: function _errorFetchFailed(err) {
      var errRes = err.response;

      if (!errRes) {
        return videojs.log.error("".concat(this._errorNamespace, ": Fetching failed. Unknown error:"), err);
      }

      var transErr = this._player.catalog.transformCatalogError(errRes.status, errRes);

      return videojs.log.error("".concat(this._errorNamespace, ": Fetching failed. Error:"), transErr);
    }
  }]);

  return VideoCatalog;
}();


// EXTERNAL MODULE: external "qs"
var external_qs_ = __webpack_require__(2);
var external_qs_default = /*#__PURE__*/__webpack_require__.n(external_qs_);

// CONCATENATED MODULE: ./src/catalogs/SevenCatalog.js
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function SevenCatalog_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function SevenCatalog_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { SevenCatalog_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { SevenCatalog_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function SevenCatalog_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SevenCatalog_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function SevenCatalog_createClass(Constructor, protoProps, staticProps) { if (protoProps) SevenCatalog_defineProperties(Constructor.prototype, protoProps); if (staticProps) SevenCatalog_defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function SevenCatalog_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var VIDEO_SERVICE_URL = 'https://videoservice.swm.digital';

var SevenCatalog_SevenCatalog =
/*#__PURE__*/
function (_Catalog) {
  _inherits(SevenCatalog, _Catalog);

  function SevenCatalog(player, config, options) {
    var _this;

    SevenCatalog_classCallCheck(this, SevenCatalog);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SevenCatalog).call(this, player, config, options));

    SevenCatalog_defineProperty(_assertThisInitialized(_this), "buildUrlParams", function () {
      var params = {
        appId: _this._options.appId,
        deviceType: _this._options.deviceType || 'web',
        platformType: _this._options.platformType || 'web',
        accountId: _this._options.accountId,
        referenceId: _this._options.videoId,
        deliveryId: _this._options.adChoice || 'ssaibeacon',
        custParams: _this._options.custParams
      };

      if (!_this._config.GDPR_MODE && !_this._options.gdprMode) {
        params.tvId = _this._options.tvId;
        params.deviceId = _this._options.deviceId;
        params.advertId = _this._options.userId || _this._getPpId();
        params.pc = _this._options.postcode;
      } else {
        params.consent = false;
      }

      return external_qs_default.a.stringify(params);
    });

    _this._options.videoServiceUrl = config.VIDEO_SERVICE_URL || VIDEO_SERVICE_URL;
    _this._options.custParams = options.custParams || config.DFP_CUST_PARAMS;
    _this._errorNamespace = 'SWMPlayer VideoService';
    return _this;
  }

  SevenCatalog_createClass(SevenCatalog, [{
    key: "fetchVideo",
    value: function () {
      var _fetchVideo = SevenCatalog_asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var params, url;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this._options.videoId) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", this._errorNoId());

              case 2:
                params = this.buildUrlParams();
                url = "".concat(this._options.videoServiceUrl, "/playback?").concat(params);
                return _context.abrupt("return", this._fetchVideoService(url));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchVideo() {
        return _fetchVideo.apply(this, arguments);
      }

      return fetchVideo;
    }()
  }]);

  return SevenCatalog;
}(VideoCatalog);


// CONCATENATED MODULE: ./src/catalogs/BrightcoveCatalog.js
function BrightcoveCatalog_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { BrightcoveCatalog_typeof = function _typeof(obj) { return typeof obj; }; } else { BrightcoveCatalog_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return BrightcoveCatalog_typeof(obj); }

function BrightcoveCatalog_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function BrightcoveCatalog_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { BrightcoveCatalog_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { BrightcoveCatalog_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function BrightcoveCatalog_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function BrightcoveCatalog_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function BrightcoveCatalog_createClass(Constructor, protoProps, staticProps) { if (protoProps) BrightcoveCatalog_defineProperties(Constructor.prototype, protoProps); if (staticProps) BrightcoveCatalog_defineProperties(Constructor, staticProps); return Constructor; }

function BrightcoveCatalog_possibleConstructorReturn(self, call) { if (call && (BrightcoveCatalog_typeof(call) === "object" || typeof call === "function")) { return call; } return BrightcoveCatalog_assertThisInitialized(self); }

function BrightcoveCatalog_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function BrightcoveCatalog_getPrototypeOf(o) { BrightcoveCatalog_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return BrightcoveCatalog_getPrototypeOf(o); }

function BrightcoveCatalog_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) BrightcoveCatalog_setPrototypeOf(subClass, superClass); }

function BrightcoveCatalog_setPrototypeOf(o, p) { BrightcoveCatalog_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return BrightcoveCatalog_setPrototypeOf(o, p); }



var BrightcoveCatalog =
/*#__PURE__*/
function (_Catalog) {
  BrightcoveCatalog_inherits(BrightcoveCatalog, _Catalog);

  function BrightcoveCatalog(player, config, options) {
    var _this;

    BrightcoveCatalog_classCallCheck(this, BrightcoveCatalog);

    _this = BrightcoveCatalog_possibleConstructorReturn(this, BrightcoveCatalog_getPrototypeOf(BrightcoveCatalog).call(this, player, config, options));
    _this._options.ppId = _this._getPpId();
    return _this;
  }

  BrightcoveCatalog_createClass(BrightcoveCatalog, [{
    key: "fetchVideo",
    value: function () {
      var _fetchVideo = BrightcoveCatalog_asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var videoId, media;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                videoId = this._options.videoId;

                if (videoId) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", this._errorNoId());

              case 3:
                _context.prev = 3;
                _context.next = 6;
                return this._getVideo(videoId);

              case 6:
                media = _context.sent;

                if (media) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return", null);

              case 9:
                if (!media.reference_id) {
                  media.reference_id = media.id;
                }

                media.dfpUrl = this._options.dfpUrl;
                return _context.abrupt("return", media);

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](3);

                this._errorFetchFailed(_context.t0);

                return _context.abrupt("return", null);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 14]]);
      }));

      function fetchVideo() {
        return _fetchVideo.apply(this, arguments);
      }

      return fetchVideo;
    }()
  }, {
    key: "_getVideo",
    value: function () {
      var _getVideo2 = BrightcoveCatalog_asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        var videoId,
            _args2 = arguments;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                videoId = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : this._options.videoId;
                return _context2.abrupt("return", new Promise(function (resolve, reject) {
                  _this2._player.catalog.getVideo(videoId, function (error, video) {
                    if (error) {
                      return reject(error);
                    }

                    resolve(video);
                  });
                }));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _getVideo() {
        return _getVideo2.apply(this, arguments);
      }

      return _getVideo;
    }()
  }]);

  return BrightcoveCatalog;
}(VideoCatalog);


// CONCATENATED MODULE: ./src/consts/ads.js
var SSAI_BEACON = 'ssaibeacon';
var SSAI_SDK = 'ssaisdk';
var CSAI = 'csai';
// CONCATENATED MODULE: ./src/consts/video.js
var VIDEO_TYPE_VOD = 'vod';
var VIDEO_TYPE_LIVE = 'live';
// CONCATENATED MODULE: ./src/plugins/AdsPlugin.js
function AdsPlugin_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { AdsPlugin_typeof = function _typeof(obj) { return typeof obj; }; } else { AdsPlugin_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return AdsPlugin_typeof(obj); }

function AdsPlugin_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AdsPlugin_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function AdsPlugin_createClass(Constructor, protoProps, staticProps) { if (protoProps) AdsPlugin_defineProperties(Constructor.prototype, protoProps); if (staticProps) AdsPlugin_defineProperties(Constructor, staticProps); return Constructor; }

function AdsPlugin_possibleConstructorReturn(self, call) { if (call && (AdsPlugin_typeof(call) === "object" || typeof call === "function")) { return call; } return AdsPlugin_assertThisInitialized(self); }

function AdsPlugin_getPrototypeOf(o) { AdsPlugin_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return AdsPlugin_getPrototypeOf(o); }

function AdsPlugin_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function AdsPlugin_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) AdsPlugin_setPrototypeOf(subClass, superClass); }

function AdsPlugin_setPrototypeOf(o, p) { AdsPlugin_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return AdsPlugin_setPrototypeOf(o, p); }

function AdsPlugin_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var SSAI_SRC = 'https://players.brightcove.net/videojs-ssai/1.4.3/videojs-ssai.js';
var SSAI_SRC_MIN = 'https://players.brightcove.net/videojs-ssai/1.4.3/videojs-ssai.min.js';
var IMA3_SRC = 'https://players.brightcove.net/videojs-ima3/3.2.4/videojs.ima3.js';
var IMA3_SRC_MIN = 'https://players.brightcove.net/videojs-ima3/3.2.4/videojs.ima3.min.js';

var AdsPlugin_AdsPlugin =
/*#__PURE__*/
function (_VendorPlugin) {
  AdsPlugin_inherits(AdsPlugin, _VendorPlugin);

  function AdsPlugin(config) {
    var _this;

    AdsPlugin_classCallCheck(this, AdsPlugin);

    _this = AdsPlugin_possibleConstructorReturn(this, AdsPlugin_getPrototypeOf(AdsPlugin).call(this, config));

    AdsPlugin_defineProperty(AdsPlugin_assertThisInitialized(_this), "pluginName", 'ads');

    var ssaiSrc = config.SSAI_UNMINIFIED_SRC ? SSAI_SRC : SSAI_SRC_MIN;
    var ima3Src = config.IMA3_UNMINIFIED_SRC ? IMA3_SRC : IMA3_SRC_MIN;
    _this._src = [ssaiSrc, ima3Src];
    return _this;
  }

  AdsPlugin_createClass(AdsPlugin, [{
    key: "afterVideo",
    value: function afterVideo(player, options) {
      var adChoice = options.adChoice,
          video = options.video,
          videoType = options.videoType;
      var dfpUrl = video.dfpUrl || this._config.IMA3_SERVER_URL;

      if (adChoice === CSAI && dfpUrl) {
        return this.ima3Init(player, options);
      }

      if (videoType === VIDEO_TYPE_LIVE) return;
      return this.ssaiInit(player, options);
    }
  }, {
    key: "ssaiInit",
    value: function ssaiInit(player, options) {
      var ssaiOptions = {
        hideOverlays: true
      };
      return this._addToQueue(function () {
        if (typeof player.ssai !== 'function') return;
        player.ssai(ssaiOptions);

        if (options.chromecast) {
          options.chromecast.on('disconnected', function () {
            player.ssai(ssaiOptions);
          });
        }

        player.ready(function () {
          var ssai = player.ssai();
          if (ssai && !ssai.state.waiting) return; // In SSAI playback, the loadstart event will not be emitted until
          // vmap has been loaded, which can often take longer than 5 seconds.
          //
          // The line below is to suppress an error in the videojs-contrib-ads
          // plugin that expects a loadstart event within 5 seconds of its
          // initialization, while a player source is present.
          //
          // In previous versions of the BC player scripts and BC SSAI plugin,
          // the player source is not appended until vmap has been loaded, hence
          // the error was never fired.

          player.ads._hasThereBeenALoadStartDuringPlayerLife = true;
        });
      });
    }
  }, {
    key: "ima3Init",
    value: function ima3Init(player, options) {
      var _this2 = this;

      return this._addToQueue(function () {
        if (typeof player.ima3 !== 'function') return;
        player.ima3({
          adTechOrder: _this2._config.IMA3_AD_TECH_ORDER || ['html5'],
          debug: _this2._defaults('IMA3_DEBUG', false),
          hardTimeouts: _this2._defaults('IMA3_HARD_TIMEOUTS', true),
          requestMode: _this2._config.IMA3_REQUEST_MODE || 'onplay',
          serverUrl: options.video.dfpUrl || _this2._config.IMA3_SERVER_URL || '',
          timeout: _this2._config.IMA3_TIMEOUT || 7000,
          useMediaCuePoints: _this2._defaults('IMA3_USE_MEDIA_CUE_POINTS', false),
          vpaidMode: _this2._config.IMA3_VPAID_MODE || 'ENABLED',
          showVpaidControls: _this2._defaults('IMA3_SHOW_VPAID_CONTROLS', true)
        });
      });
    }
  }, {
    key: "_defaults",
    value: function _defaults(key, defaultValue) {
      return this._config.hasOwnProperty(key) ? this._config[key] : defaultValue;
    }
  }]);

  return AdsPlugin;
}(utils_["VendorPlugin"]);


// EXTERNAL MODULE: ./package.json
var package_0 = __webpack_require__(1);

// CONCATENATED MODULE: ./src/SWMPlayer.js
function SWMPlayer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function SWMPlayer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { SWMPlayer_ownKeys(source, true).forEach(function (key) { SWMPlayer_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { SWMPlayer_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SWMPlayer_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function SWMPlayer_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function SWMPlayer_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { SWMPlayer_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { SWMPlayer_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function SWMPlayer_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SWMPlayer_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function SWMPlayer_createClass(Constructor, protoProps, staticProps) { if (protoProps) SWMPlayer_defineProperties(Constructor.prototype, protoProps); if (staticProps) SWMPlayer_defineProperties(Constructor, staticProps); return Constructor; }


console.log('annen', {
  events: utils_["events"]
});











var SWMPlayer_SWMPlayer =
/*#__PURE__*/
function () {
  function SWMPlayer() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    SWMPlayer_classCallCheck(this, SWMPlayer);

    this.VERSION = package_0["a" /* version */];
    this._config = config;
    this._plugins = [];
    this._Catalog = config.USE_BRIGHTCOVE_CATALOG ? BrightcoveCatalog : SevenCatalog_SevenCatalog;
    this._setupPromise = null;
  }

  SWMPlayer_createClass(SWMPlayer, [{
    key: "plugins",
    value: function plugins() {
      var _this = this;

      var userPlugins = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var plugins = [AdsPlugin_AdsPlugin].concat(_toConsumableArray(userPlugins));
      this._plugins = plugins.map(function (Plugin) {
        return new Plugin(_this._config);
      });
    }
  }, {
    key: "setCatalog",
    value: function setCatalog(Catalog) {
      if (Catalog && Catalog.prototype instanceof VideoCatalog) {
        return this._Catalog = Catalog;
      }

      return videojs.log.error('SWMPlayer setupCatalog: Catalog is invalid');
    }
  }, {
    key: "init",
    value: function () {
      var _init = SWMPlayer_asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var initializePlayers,
            players,
            _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                initializePlayers = _args.length > 0 && _args[0] !== undefined ? _args[0] : true;
                if (!this._setupPromise) this._setupPromise = this._setup();
                _context.next = 4;
                return this._setupPromise;

              case 4:
                if (initializePlayers) {
                  players = this._getPlayers();
                  players.forEach(function (player) {
                    return _this2._run(player);
                  });
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "_setup",
    value: function () {
      var _setup2 = SWMPlayer_asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var options,
            adBlockSetup,
            postcodeSetup,
            telariaSetup,
            loadVendors,
            versions,
            _ref,
            _ref2,
            adBlock,
            postcode,
            telariaId,
            _args2 = arguments;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
                adBlockSetup = new AdBlock(this._config);
                postcodeSetup = new Postcode(this._config);
                telariaSetup = new Telaria_Telaria(this._config, options);
                loadVendors = [];
                versions = {
                  swmPlayer: this.VERSION,
                  bc: typeof window.bc === 'function' ? window.bc.VERSION : null,
                  videojs: videojs.VERSION
                };

                this._plugins.forEach(function (plugin) {
                  if (plugin.constructor.VERSION) {
                    versions[plugin.pluginName] = plugin.constructor.VERSION;
                  }

                  if (plugin.isVendor && plugin._autoLoad) {
                    loadVendors.push(plugin.load());
                  }
                });

                _context2.next = 9;
                return Promise.all([adBlockSetup.resolve(), postcodeSetup.fetch(), telariaSetup.fetch()].concat(loadVendors));

              case 9:
                _ref = _context2.sent;
                _ref2 = _slicedToArray(_ref, 3);
                adBlock = _ref2[0];
                postcode = _ref2[1];
                telariaId = _ref2[2];
                this.setupOptions = {
                  adBlock: adBlock,
                  postcode: postcode,
                  telariaId: telariaId,
                  versions: versions
                };

                if (this._config.GDPR_MODE) {
                  this.setupOptions.gdprMode = true;
                }

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _setup() {
        return _setup2.apply(this, arguments);
      }

      return _setup;
    }()
  }, {
    key: "_run",
    value: function () {
      var _run2 = SWMPlayer_asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3(player) {
        var extraOptions,
            _args3 = arguments;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                extraOptions = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
                player.swmOptions = SWMPlayer_objectSpread({}, this.setupOptions, {}, extraOptions);

                this._adChoice(player, extraOptions);

                _context3.next = 5;
                return this._beforeVideo(player);

              case 5:
                _context3.next = 7;
                return this._loadVideo(player);

              case 7:
                _context3.next = 9;
                return this._afterVideo(player);

              case 9:
                return _context3.abrupt("return", player);

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function _run(_x) {
        return _run2.apply(this, arguments);
      }

      return _run;
    }()
  }, {
    key: "_adChoice",
    value: function _adChoice(player, extraOptions) {
      var dataAds = player.el().getAttribute('data-ads');
      var adChoice = SSAI_BEACON;

      if (dataAds === SSAI_BEACON || dataAds === SSAI_SDK || dataAds === CSAI) {
        adChoice = dataAds;
      } else if (extraOptions.adChoice) {
        adChoice = extraOptions.adChoice;
      } else if (!this._config.DISABLE_CLIENT_ADS && !player.swmOptions.adBlock) {
        adChoice = CSAI;
      }

      if (adChoice === SSAI_BEACON) player.preload('none');
      player.swmOptions.adChoice = adChoice;
      this.setupOptions.adChoice = adChoice;
    }
  }, {
    key: "_beforeVideo",
    value: function () {
      var _beforeVideo2 = SWMPlayer_asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4(player) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return Promise.all(this._plugins.map(function (plugin) {
                  return plugin.beforeVideo(player, player.swmOptions);
                }));

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function _beforeVideo(_x2) {
        return _beforeVideo2.apply(this, arguments);
      }

      return _beforeVideo;
    }()
  }, {
    key: "_loadVideo",
    value: function () {
      var _loadVideo2 = SWMPlayer_asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee5(player) {
        var catalog, media, video;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!player.swmOptions.stopVideoLoad) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt("return");

              case 2:
                catalog = new this._Catalog(player, this._config, player.swmOptions);
                _context5.next = 5;
                return catalog.fetchVideo();

              case 5:
                media = _context5.sent;
                video = player.catalog.transformVideoResponse(media);
                player.mediainfo = video;
                player.swmOptions.video = video;
                player.swmOptions.videoType = this._getVideoType(video);
                player.catalog.load(video);

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function _loadVideo(_x3) {
        return _loadVideo2.apply(this, arguments);
      }

      return _loadVideo;
    }()
  }, {
    key: "_afterVideo",
    value: function () {
      var _afterVideo2 = SWMPlayer_asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee6(player) {
        var mapAfterVideo;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (player.swmOptions.video) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt("return");

              case 2:
                mapAfterVideo = player.swmOptions.stopVideoLoad ? function (plugin) {
                  if (!plugin.bypassStopVideoLoad) return;
                  return plugin.afterVideo(player, player.swmOptions);
                } : function (plugin) {
                  return plugin.afterVideo(player, player.swmOptions);
                };
                _context6.next = 5;
                return Promise.all(this._plugins.map(mapAfterVideo));

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function _afterVideo(_x4) {
        return _afterVideo2.apply(this, arguments);
      }

      return _afterVideo;
    }()
  }, {
    key: "fetchMetadata",
    value: function () {
      var _fetchMetadata = SWMPlayer_asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee7(id) {
        var extraOptions,
            player,
            options,
            catalog,
            _args7 = arguments;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                extraOptions = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : {};
                player = videojs.getPlayer(id);

                if (player) {
                  _context7.next = 4;
                  break;
                }

                return _context7.abrupt("return", this._errorPlayerNotFound(id, 'getMetadata'));

              case 4:
                options = SWMPlayer_objectSpread({}, this.setupOptions, {}, extraOptions);
                _context7.next = 7;
                return Promise.all(this._plugins.map(function (plugin) {
                  return plugin.beforeMetadata && plugin.beforeMetadata(player, options);
                }));

              case 7:
                catalog = new this._Catalog(player, this._config, options);
                return _context7.abrupt("return", catalog.fetchVideo());

              case 9:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function fetchMetadata(_x5) {
        return _fetchMetadata.apply(this, arguments);
      }

      return fetchMetadata;
    }()
  }, {
    key: "loadFromMetadata",
    value: function loadFromMetadata(id, media) {
      var player = videojs.getPlayer(id);
      if (!player) return this._errorPlayerNotFound(id, 'loadFromMetadata');
      var video = player.catalog.transformVideoResponse(media);

      if (player.ima3 && player.ima3.settings && video.dfpUrl) {
        player.ima3.settings.serverUrl = video.dfpUrl;
      }

      if (!player.swmOptions) player.swmOptions = {};
      player.swmOptions.video = video;
      player.swmOptions.videoType = this._getVideoType(video);
      player.trigger(utils_["events"].player.contentWillUpdate);
      player.catalog.load(video);
    }
  }, {
    key: "initPlayer",
    value: function () {
      var _initPlayer = SWMPlayer_asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee8(id) {
        var options,
            player,
            _args8 = arguments;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                options = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : {};
                if (typeof window.bc === 'function') window.bc(id);
                if (!this._setupPromise) this._setupPromise = this._setup(options);
                _context8.next = 5;
                return this._setupPromise;

              case 5:
                player = videojs.getPlayer(id);

                if (player) {
                  _context8.next = 8;
                  break;
                }

                return _context8.abrupt("return", this._errorPlayerNotFound(id, 'initPlayer'));

              case 8:
                return _context8.abrupt("return", this._run(player, options));

              case 9:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function initPlayer(_x6) {
        return _initPlayer.apply(this, arguments);
      }

      return initPlayer;
    }()
  }, {
    key: "dispose",
    value: function dispose(id) {
      var player = videojs.getPlayer(id);

      if (!player) {
        return this._errorPlayerNotFound(id, 'dispose');
      }

      try {
        this._disposePlugins();
      } finally {
        player.dispose();
      }
    }
  }, {
    key: "_disposePlugins",
    value: function _disposePlugins() {
      this._plugins.map(function (plugin) {
        return plugin.dispose();
      });
    }
  }, {
    key: "_getPlayers",
    value: function _getPlayers() {
      var players = videojs.getAllPlayers();

      if (!players.length) {
        videojs.log.warn('No player(s) found');
        return [];
      }

      return players;
    }
  }, {
    key: "_getVideoType",
    value: function _getVideoType(video) {
      if (video.customFields && video.customFields.video_type) {
        return video.customFields.video_type;
      }

      return VIDEO_TYPE_VOD;
    }
  }, {
    key: "_errorPlayerNotFound",
    value: function _errorPlayerNotFound(id, namespace) {
      var error = typeof id === 'string' ? "SWMPlayer ".concat(namespace, ": ").concat(id, " not found") : "SWMPlayer ".concat(namespace, ": node not found");
      return videojs.log.error(error);
    }
  }]);

  return SWMPlayer;
}();


// CONCATENATED MODULE: ./src/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Catalog", function() { return src_Catalog; });


var src_Catalog = VideoCatalog;
/* harmony default export */ var src = __webpack_exports__["default"] = (SWMPlayer_SWMPlayer);

/***/ })
/******/ ]);